module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-13.6f4391c7.png";